import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

/**
 * Password input with show/hide eye toggle.
 * Drop-in replacement for <input type="password" />.
 * Forwards all extra props to the inner <input>.
 */
export default function PasswordInput({
  value,
  onChange,
  className = "",
  testId,
  toggleTestId,
  ...rest
}) {
  const [shown, setShown] = useState(false);
  return (
    <div className="relative">
      <input
        type={shown ? "text" : "password"}
        value={value}
        onChange={onChange}
        className={`pr-11 ${className}`}
        data-testid={testId}
        {...rest}
      />
      <button
        type="button"
        onClick={() => setShown((s) => !s)}
        aria-label={shown ? "Hide password" : "Show password"}
        title={shown ? "Hide password" : "Show password"}
        className="absolute inset-y-0 right-0 flex items-center px-3 text-white/40 hover:text-electric transition-colors"
        data-testid={toggleTestId || (testId ? `${testId}-toggle` : undefined)}
      >
        {shown ? <EyeOff size={16} /> : <Eye size={16} />}
      </button>
    </div>
  );
}
